module.exports = __webpack_public_path__ + "img/alarm-clock-check.1f5f87bc.svg";